import it from './messages.it_IT';
import en from './messages.en_EN';
// eslint-disable-next-line camelcase
import it_arca from './messages.it_IT_arca';
// eslint-disable-next-line camelcase
import it_migross from './messages.it_IT_migross';

const messageList = { it, en, it_arca, it_migross };
export default messageList;
